import { AVATAR_SHADER } from "./AvatarShader";
import { ShaderMaterial, Mesh, BufferAttribute, Uniform } from "three";
import { Color } from "flavr-math";
/**
 * Applies the user-wireframe-material to the given meshes.
 * Also makes all necessary preperations for that.
 * @param group
 * @param needsBarycentricCoordinates
 * @needsBarycentricCoordinates set this to true if you have not called addBarycentricCoordinates on the mesh earlier.
 */
export function applyUserWireframeToMeshes(group, needsBarycentricCoordinates = true) {
    const material = createWireframeMaterial();
    // Add Barycentric Coordinates to all vertices of all Geometries (for our wireframe-shader):
    group.traverse((child) => {
        if (child instanceof Mesh) {
            if (needsBarycentricCoordinates) {
                const bufferGeometry = getBufferGeometryFromThreeMesh(child);
                addBarycentricCoordinates(bufferGeometry);
            }
            child.material = material;
        }
    });
}
/**
 * To render wireframes in a single pass, we need barycentric coordinates.
 * @see https://github.com/mattdesl/webgl-wireframes
 */
export function addBarycentricCoordinates(bufferGeometry, removeEdge = false) {
    const attrib = bufferGeometry.getIndex() || bufferGeometry.getAttribute("position");
    const count = attrib.count / 3;
    const barycentric = [];
    // for each triangle in the geometry, add the barycentric coordinates
    for (let i = 0; i < count; i++) {
        const even = i % 2 === 0;
        const Q = removeEdge ? 1 : 0;
        if (even) {
            barycentric.push(0, 0, 1, 0, 1, 0, 1, 0, Q);
        }
        else {
            barycentric.push(0, 1, 0, 0, 0, 1, 1, 0, Q);
        }
    }
    // add the attribute to the geometry
    const array = new Float32Array(barycentric);
    const attribute = new BufferAttribute(array, 3);
    bufferGeometry.setAttribute("barycentric", attribute);
}
export function applyBarycentricCoordinatesToGroup(group) {
    // Add Barycentric Coordinates to all vertices of all Geometries (for our wireframe-shader):
    group.traverse((child) => {
        if (child instanceof Mesh) {
            const bufferGeometry = child.geometry;
            addBarycentricCoordinates(bufferGeometry);
        }
    });
}
export function createWireframeMaterial() {
    const material = new ShaderMaterial(AVATAR_SHADER);
    material.uniforms = Object.assign({}, material.uniforms);
    material.uniforms.strokeColor = new Uniform(new Color());
    material.uniforms.baseColor = new Uniform(new Color());
    return material;
}
/**
 * Provides BufferGeometry from a Mesh.
 * (Will take the existing BufferGeometry or will create a BufferGeometry from the Mesh's Geometry.)
 * Note: Has an odd name, since the mesh from three has the alias ThreeMesh here.
 * */
function getBufferGeometryFromThreeMesh(threeMesh) {
    return threeMesh.geometry;
}
